"use strict";Object.defineProperty(exports,"__esModule",{value:true});var checkVisibility=exports.checkVisibility=function checkVisibility(roles,allowed,except){if(except.length>0&&except.some(function(elem){return roles.indexOf(elem)>-1})){return false}if(allowed.length>0){if(allowed.some(function(elem){return roles.indexOf(elem)>-1})){return true}return false}return true};exports.default={checkVisibility:checkVisibility};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-permissions/dist/core.js
// module id = 455
// module chunks = 1